import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { CoreStorageFilesUploadComponent } from '@core/components/storage/storage-files-upload/storage-files-upload.component';

import { WysiwygData } from '@core/models/wysiwyg-data.model';

import * as Objects from '@core/objects';
interface MessageAddFormData {
    message: string;
    files: string[];
}

@Component({
  selector: 'core-message-add-form',
  templateUrl: './message-add-form.component.html',
  styleUrls: ['./message-add-form.component.scss'],
})
export class MessageAddFormComponent implements OnInit {
    protected readonly PLUGIN_SHARE_FEEDBACK_CONTEXT = 'plugin-share-feedback';
    protected readonly PLUGIN_SHARE_UPLOAD_VERSION_CONTEXT = 'plugin-share-upload-version';
    protected readonly MESSAGE_SHARE_FEEDBACK_CONTEXT = 'message-share-feedback';

    @ViewChild(CoreStorageFilesUploadComponent) uploader: CoreStorageFilesUploadComponent;

    @Input() placeholder: any = '';
    @Input() context: string = 'default'; // this will manage if message form is in app (deafult) or feedback (share)
    @Input() hash: string = ''; // Used in case of context feedback (share)

    @Output() onSubmit = new EventEmitter<any>();
    @Output() onCancel = new EventEmitter<any>();

    public files: Objects.FileMetadata[] = [];
    public buttonDisabled:boolean = true;
    public uploading: boolean = false;
    public dataSend:any;
    public messageFilesUrlPrefix: string = '';
    public messageContent: string = '';
    public storageFilesUrlPrefix: string = '';

    ngOnInit() {
        if (this.context == 'default')
            return;
        // console.debug(" Placeholder ", this.placeholder)
        if( this.context == 'feedback' && this.hash != ''){
            this.messageFilesUrlPrefix = "/web/share/p/feedback/"+this.hash;
        }
        if ( this.context == this.PLUGIN_SHARE_FEEDBACK_CONTEXT && this.hash != ''){
            this.storageFilesUrlPrefix = "/share/feedback/"+this.hash;
        }
        if ( this.context == this.PLUGIN_SHARE_UPLOAD_VERSION_CONTEXT && this.hash != ''){
            this.storageFilesUrlPrefix = "/share/upload-version/"+this.hash;
        }
        if ( this.context == this.MESSAGE_SHARE_FEEDBACK_CONTEXT && this.hash != ''){
            this.storageFilesUrlPrefix = "/share/feedback/"+this.hash;
        }
    }


    sendMessage(e: any){
        this.dataSend = {
            message: this.messageContent,
            files: []
        };
        // Method send message with the textarea and files
        
        this.dataSend.files = this.files.map((e) => { return e.uuid; } );
        // console.log(" Message to send: dataSend", this.dataSend);

        if(this.dataSend.message != '' && this.dataSend.message != undefined && this.dataSend.message != null){
            this.onSubmit.emit(this.dataSend);
        }
    }

    public upload(files: Objects.FileMetadata[]) {
        this.files = files;
    }

    public clean() {
        // console.log("clean form");
        this.messageContent = '';
        this.files = [];
        this.uploader.files.clear();
    }


    cancel(){
        this.clean();
        this.onCancel.emit();
    }

    onMessageChange(msgData: WysiwygData){

        // console.log("onMessageChange form", msgData.html);
        // to update current var of content to make detect changes on cancel.
        this.messageContent = msgData.html; // need to be updated to send to save message
        this.buttonDisabled = false;
        if(msgData.text.trim() == '')
            this.buttonDisabled = true;
    }

}
